<script>
export default {
  name: 'Title',
  props: ['title', 'sub'],
}
</script>

//Bon, au final si je le remonte autant ça pourrait être intégrer à l'élément banner... Mais au moins comme ça c'est souple...

<template>
  <div class="pageTitle">
    <h1 class="pageTitle__title"> {{title}} </h1>
    <div v-if= sub class="pageTitle__sub">{{sub}} </div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.pageTitle{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -155px 0 60px 0;
  border: solid 4px white;
  // border-radius: 15px;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(1.5px); //From version 70: this feature is behind the layout.css.backdrop-filter.enabled preference (needs to be set to true) and the gfx.webrender.all preference (needs to be set to true). To change preferences in Firefox, visit about:config.
  padding: 5px 25px 5px 25px;
  // box-shadow: 0px 0px 5px 2px rgba(150, 150, 150, 0.2);
  min-width: 500px;
  // min-height: 120px;

  &__title{
    color: white;
  }

  &__sub{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    color: white;
    margin: -20px 0 20px 0;
  }
}

</style>
